import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAuth } from "../../hooks/useAuth";
import { setToken } from "../../store/authentication/authSlice";
import { getAccessCookieName, getCookie } from "../../utils";

const TokenProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { access_token } = useAuth();
  const cookieToken = getCookie(getAccessCookieName());

  useEffect(() => {
    if (!access_token && cookieToken) {
      dispatch(setToken(decodeURIComponent(cookieToken)));
    }
  }, [cookieToken]);

  return children;
};

export default TokenProvider;
